let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("b5UZH")).then(() => parcelRequire('6Bhs5'));